import React from 'react';
import { useChatContext, useMessageContext, useTranslationContext } from '../../context';
import { ButtonWithSubmenu } from '../Dialog';
export const RemindMeActionButton = ({ className, isMine, }) => {
    const { t } = useTranslationContext();
    return (React.createElement(ButtonWithSubmenu, { "aria-selected": 'false', className: className, placement: isMine ? 'left-start' : 'right-start', Submenu: RemindMeSubmenu }, t('Remind Me')));
};
export const RemindMeSubmenu = () => {
    const { t } = useTranslationContext();
    const { client } = useChatContext();
    const { message } = useMessageContext();
    return (React.createElement("div", { "aria-label": t('aria/Remind Me Options'), className: 'str-chat__message-actions-box__submenu', role: 'listbox' }, client.reminders.scheduledOffsetsMs.map((offsetMs) => (React.createElement("button", { className: 'str-chat__message-actions-list-item-button', key: `reminder-offset-option--${offsetMs}`, onClick: () => {
            client.reminders.upsertReminder({
                messageId: message.id,
                remind_at: new Date(new Date().getTime() + offsetMs).toISOString(),
            });
        } }, t('duration/Remind Me', { milliseconds: offsetMs }))))));
};
